import { render, staticRenderFns } from "./OpenInVisio.vue?vue&type=template&id=c5f19074"
import script from "./OpenInVisio.vue?vue&type=script&lang=js"
export * from "./OpenInVisio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports